export default {
    namespaced: true,
    state: {
        companions: [],
        diggingPower: 0,
        diggingDistance: 0,
        level: 1,
        levelPercentage: 0,
        storage: [],
        storageSpace: 0,
        storageUpgradeCost: 0,
        locationSlots: [null, null, null, null],
        slotLocations: [
            {x: 530, y: 330},
            {x: 130, y: 170},
            {x: 830, y: 170},
            {x: 150, y: 450},
            {x: 850, y: 430}
        ]
    },
    getters: {
        level(state) { return state.level; },
        storageSpace(state) { return state.storageSpace; },
        levelPercentage(state) { return state.levelPercentage; },
        diggingDistance(state) { return state.diggingDistance; },
        locationSlots(state) { return state.locationSlots; },
        slotLocations(state) { return state.slotLocations; },
        companions(state) { return state.companions; },
        storage(state) { return state.storage; },
        storageUpgradeCost(state) { return state.storageUpgradeCost; },
        diggingPower(state) { return state.diggingPower; }
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        companionAdded(state, data){
            state.companions.push(data);
        },
        occupySlotStatus(state, data){
            state.locationSlots[data.index] = data.value;
        }
    },
    actions: {
        setData({ commit }, data) {
            return new Promise((approve, reject) => {
                this.getters.socket.emit("cave/get_data", (result) => {
                    commit('setValue', ["companions", result.companions]);
                    commit('setValue', ["storage", result.storage]);
                    commit('setValue', ["storageSpace", result.storageSpace]);
                    commit('setValue', ["storageUpgradeCost", result.storageUpgradeCost]);
                    commit('setValue', ["diggingPower", result.diggingPower]);
                    commit('setValue', ["diggingDistance", result.diggingDistance]);
                    commit('setValue', ["level", result.level]);
                    commit('setValue', ["levelPercentage", result.levelPercentage]);
                    approve(result);
                });
            });
        },
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        occupySlotStatus({ commit }, data) {
            commit('occupySlotStatus', data)
        },
        placeCompanion({ commit, state }, data) {
            return new Promise((approve, reject) => {
                this.getters.socket.emit("cave/place_companion", data , (result) => {
                    commit('companionAdded', {
                        position: data.position,
                        companion_id: data.id,
                        id: result.id,
                        diggingPower: result.diggingPower,
                        bonuses: result.bonuses
                    });
                    approve(result);
                });
            });
        },
        removeCompanion({ commit, state }, data) {
            return new Promise((approve, reject) => {
                this.getters.socket.emit("cave/remove_companion", {locID : data.id} , (result) => {
                    commit('setValue', ["companions", state.companions.filter(a => a.id !== data.id)]);
                    approve(result);
                });
            });
        }
    }
};